import { tap } from 'rxjs/operators';
import { EventEmitter, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressInterceptor implements HttpInterceptor {
  constructor(private progressSpinnerService: ProgressSpinnerService) {
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!(req.body && req.body['silent'])) {
      this.progressSpinnerService.increase();
    }
    return next
      .handle(req).pipe(
        tap({
          next: (event) => {
            if (event instanceof HttpResponse) {
              if (!(req.body && req.body['silent'])) {
                this.progressSpinnerService.decrease();
              }
            }
          },
          error: () => {
            if (!(req.body && req.body['silent'])) {
              this.progressSpinnerService.decrease();
            }
          }
        })
      );
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProgressSpinnerService {

  public updateProgressSpinner: EventEmitter<boolean>;

  private requestsRunning = 0;

  constructor() {
    this.updateProgressSpinner = new EventEmitter(true);
  }

  public increase(): void {
    this.requestsRunning++;
    if (this.requestsRunning === 1) {
      this.updateProgressSpinner.emit(true);
    }
  }

  public decrease(): void {
    if (this.requestsRunning > 0) {
      this.requestsRunning--;
      if (this.requestsRunning === 0) {
        this.updateProgressSpinner.emit(false);
      }
    }
  }
}
